export default "__VITE_ASSET__fc2be51b__"